import React from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import NumberFormat from 'react-number-format';
import { ENABLE_GOLD_WALLET_IN_CART } from '../../themeSetting';
import { getGoldGramDeductionToman, applyGoldGramDeduction } from '../../helper';
import { usePaymentGatewaySettings } from '../../hooks/usePaymentGatewaySettings';
import { formatGatewayLimit } from '../../services/paymentGateway';

const ConfirmationModal = ({
  show = false,
  onHide = () => {},
  onConfirm = () => {},
  balance = {},
  shippingPrice = 0,
  selectedShipping = null,
  cartReport = {},
  payType = 'cashe',
  depositPrice = 0,
  credit = 0,
  discount = { amount: 0, success: false },
  onDiscountClick = () => {},
}) => {
  const user = useSelector((state) => state.user);
  const gold = useSelector((state) => state.gold_price);
  const translate = useSelector((state) => getTranslate(state.localize));
  const goldGramCartUsage = useSelector((state) => state.cart.gold_gram_cart_usage) || 0;
  const goldGramCartToman = getGoldGramDeductionToman(goldGramCartUsage, gold);
  const { maxAmountToman } = usePaymentGatewaySettings();

  const { pool = 0, gram = 0, beyane = 0, mandeHesabPrice = 0, creditor = 0 } = balance;
  const gramPrice = gram * gold;
  const totalBalance = pool;

  console.log(parseInt(+shippingPrice + +cartReport.total_price));

  // محاسبه مبلغ نهایی برای پرداخت
  const calculateFinalPayment = () => {
    const totalCartPrice = parseFloat(cartReport.total_price) || 0;
    const shippingCost = parseFloat(shippingPrice + '0') / 10;
    const discountAmount = discount?.amount / 10 || 0;

    if (payType === 'deposit') {
      if (credit <= 0) {
        return depositPrice - discountAmount;
      } else if (depositPrice - credit / 10 <= 0) {
        return 0; // از کیف پول برداشت می‌شود
      } else {
        return depositPrice - discountAmount - credit / 10;
      }
    } else {
      // پرداخت نقدی
      let amount = totalCartPrice - discountAmount + shippingCost - goldGramCartToman;
      if (totalCartPrice + shippingCost >= maxAmountToman) {
        return Math.max(0, maxAmountToman - goldGramCartToman);
      }
      return Math.max(0, amount);
    }
  };

  const renderTeammateContent = () => {
    if (pool > 0 && gram <= 0) {
      return (
        <>
          <span>
            شما مبلغ <NumberFormat value={pool / 10} displayType={'text'} thousandSeparator={true} /> تومان بستانکار هستید و هزینه ارسال
            {shippingPrice === 0 ? (
              selectedShipping === 1 ? (
                ' را درب منزل پرداخت کنید. '
              ) : (
                ' رایگان است'
              )
            ) : (
              <>
                <NumberFormat value={shippingPrice} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
                است.
              </>
            )}
          </span>
          <br />
          <span>
            آیا موافقید که مبلغ پیش‌پرداخت این سفارش، معادل <NumberFormat value={beyane / 10} displayType={'text'} thousandSeparator={true} /> تومان از حسابتان کسر شود{' '}
            {pool < beyane ? (
              <span>
                و مبلغ نهایی <NumberFormat value={(beyane - pool) / 10} displayType={'text'} thousandSeparator={true} /> تومان را از طریق درگاه بانک پرداخت کنید؟
              </span>
            ) : (
              '؟'
            )}
          </span>
        </>
      );
    } else if (pool <= 0 && gram > 0) {
      return (
        <>
          <span>
            شما مقدار {gram} گرم طلا، معادل <NumberFormat value={gramPrice / 10} displayType={'text'} thousandSeparator={true} /> تومان بستانکار هستید و هزینه ارسال{' '}
            {shippingPrice === 0 ? (
              selectedShipping === 1 ? (
                ' را درب منزل پرداخت کنید. '
              ) : (
                ' رایگان است'
              )
            ) : (
              <>
                <NumberFormat value={shippingPrice} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
                است.
              </>
            )}
          </span>
          <br />
          <span>
            آیا موافقید که مبلغ پیش‌پرداخت این سفارش، معادل <NumberFormat value={beyane / 10} displayType={'text'} thousandSeparator={true} /> تومان از حسابتان کسر شود{' '}
            {gramPrice < beyane ? (
              <span>
                و مبلغ نهایی <NumberFormat value={mandeHesabPrice / 10} displayType={'text'} thousandSeparator={true} /> تومان را از طریق درگاه بانک پرداخت کنید؟
              </span>
            ) : (
              '؟'
            )}
          </span>
        </>
      );
    } else if (pool > 0 && gram > 0) {
      return (
        <>
          <span>
            شما مبلغ <NumberFormat value={pool / 10} displayType={'text'} thousandSeparator={true} /> تومان و مقدار {gram} گرم طلا، در مجموع{' '}
            <NumberFormat value={totalBalance / 10} displayType={'text'} thousandSeparator={true} /> تومان بستانکار هستید و هزینه ارسال{' '}
            {parseInt(shippingPrice) === 0 ? (
              selectedShipping === 1 ? (
                ' را درب منزل پرداخت کنید. '
              ) : (
                ' رایگان است'
              )
            ) : (
              <>
                <NumberFormat value={parseInt(shippingPrice)} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
                است.
              </>
            )}
          </span>
          <br />
          <span>
            آیا موافقید که مبلغ پیش‌پرداخت این سفارش، معادل <NumberFormat value={beyane / 10} displayType={'text'} thousandSeparator={true} /> تومان از حسابتان کسر شود{' '}
            {pool + gramPrice / 10 < beyane ? (
              <span>
                و مبلغ نهایی <NumberFormat value={mandeHesabPrice / 10} displayType={'text'} thousandSeparator={true} /> تومان را از طریق درگاه بانک پرداخت کنید؟
              </span>
            ) : (
              '؟'
            )}
          </span>
        </>
      );
    } else {
      return (
        <>
          <span>
            هزینه ارسال{' '}
            {parseInt(shippingPrice) === 0 ? (
              selectedShipping === 1 ? (
                ' را درب منزل پرداخت کنید. '
              ) : (
                ' رایگان است '
              )
            ) : (
              <>
                <NumberFormat value={parseInt(shippingPrice)} displayType={'text'} suffix=' تومان ' thousandSeparator={true} />
              </>
            )}{' '}
            و مبلغ پیش‌پرداخت این سفارش، معادل <NumberFormat value={beyane / 10} displayType={'text'} thousandSeparator={true} /> تومان است.
          </span>
          <br />
          <span>
            آیا موافقید مبلغ نهایی <NumberFormat value={beyane / 10} displayType={'text'} thousandSeparator={true} /> تومان را از طریق درگاه بانک پرداخت کنید؟
          </span>
        </>
      );
    }
  };

  const renderRegularUserContent = () => {
    const finalPayment = calculateFinalPayment();

    return (
      <>
        <span style={{ fontWeight: 'bold' }}>مشتری گرامی،</span>
        <br />

        {/* محدودیت درگاه بانکی */}
        {parseInt(+shippingPrice + +cartReport.total_price) >= maxAmountToman && payType === 'cashe' && (
          <>
            <span>
              بدلیل محدودیت درگاه بانکی مبلغ {formatGatewayLimit(maxAmountToman)} از طریق درگاه از شما دریافت میگردد و همکاران ما برای پرداخت مانده حساب(
              <NumberFormat value={parseInt(+shippingPrice + +cartReport.total_price) - maxAmountToman} displayType={'text'} thousandSeparator={true} /> تومان) از طریق کارت به
              کارت یا حواله پایا با شما تماس خواهند گرفت.
            </span>
            <br />
            <br />
          </>
        )}

        {/* نمایش وضعیت حساب */}
        {totalBalance > 0 && (
          <>
            <span>
              شما مبلغ <NumberFormat value={totalBalance / 10} displayType={'text'} thousandSeparator={true} /> تومان بستانکار هستید
            </span>
            <br />
          </>
        )}
        {totalBalance < 0 && (
          <>
            <span>
              شما مبلغ <NumberFormat value={0 - totalBalance / 10} displayType={'text'} thousandSeparator={true} /> تومان بدهکار هستید
            </span>
            <br />
          </>
        )}

        {/* اطلاعات سبد خرید */}
        <span>
          مبلغ سبد خرید شما <NumberFormat value={cartReport.total_price} displayType={'text'} thousandSeparator={true} /> تومان و هزینه ارسال
          {parseInt(shippingPrice) === 0 ? (
            selectedShipping === 1 ? (
              ' را درب منزل پرداخت کنید. '
            ) : (
              ' رایگان است '
            )
          ) : (
            <NumberFormat value={parseInt(shippingPrice)} suffix=' تومان ' displayType={'text'} thousandSeparator={true} />
          )}
          {discount.amount > 0 && (
            <>
              مبلغ <NumberFormat value={discount.amount / 10} displayType={'text'} thousandSeparator={true} /> تومان بابت تخفیف از صورت حساب شما کسر شده
            </>
          )}
        </span>

        <br />

        {/* نحوه پرداخت */}
        {totalBalance === 0 ? (
          <span>
            {payType === 'deposit' ? (
              credit <= 0 ? (
                <>
                  آیا مایلید که با مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0)} displayType={'text'} thousandSeparator={true} /> تومان، به درگاه پرداخت
                  بروید؟
                </>
              ) : depositPrice - credit / 10 <= 0 ? (
                <>
                  مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0)} displayType={'text'} thousandSeparator={true} /> تومان از کیف پول شما بابت بیعانه برداشت
                  خواهد شد.
                </>
              ) : (
                <>
                  آیا مایلید که با مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0) - credit / 10} displayType={'text'} thousandSeparator={true} /> تومان، به
                  درگاه پرداخت بروید؟
                </>
              )
            ) : (
              <>
                آیا مایلید که با مبلغ <NumberFormat value={finalPayment} displayType={'text'} thousandSeparator={true} /> تومان، به درگاه پرداخت بروید؟
              </>
            )}
          </span>
        ) : creditor === 0 ? (
          totalBalance > 0 ? (
            <span>
              {payType === 'deposit' ? (
                credit <= 0 ? (
                  <>
                    لطفا مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0)} displayType={'text'} thousandSeparator={true} /> تومان را نیز از طریق درگاه، پرداخت
                    نمایید.
                  </>
                ) : depositPrice - credit / 10 <= 0 ? (
                  <>
                    مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0)} displayType={'text'} thousandSeparator={true} /> تومان از کیف پول شما بابت بیعانه برداشت
                    خواهد شد.
                  </>
                ) : (
                  <>
                    لطفا مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0) - credit / 10} displayType={'text'} thousandSeparator={true} /> تومان را نیز از طریق
                    درگاه، پرداخت نمایید.
                  </>
                )
              ) : (
                <>
                  لطفا مبلغ{' '}
                  <NumberFormat value={(mandeHesabPrice - (discount?.amount / 10 || 0) + parseInt(shippingPrice + '0')) / 10} displayType={'text'} thousandSeparator={true} /> تومان
                  را نیز از طریق درگاه، پرداخت نمایید.
                </>
              )}
            </span>
          ) : (
            <span>
              {payType === 'deposit' ? (
                credit <= 0 ? (
                  <>
                    لطفا مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0)} displayType={'text'} thousandSeparator={true} /> تومان را نیز از طریق درگاه، پرداخت
                    نمایید.
                  </>
                ) : depositPrice - credit / 10 <= 0 ? (
                  <>
                    مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0)} displayType={'text'} thousandSeparator={true} /> تومان از کیف پول شما بابت بیعانه برداشت
                    خواهد شد.
                  </>
                ) : (
                  <>
                    لطفا مبلغ <NumberFormat value={depositPrice - (discount?.amount / 10 || 0) - credit / 10} displayType={'text'} thousandSeparator={true} /> تومان را نیز از طریق
                    درگاه، پرداخت نمایید.
                  </>
                )
              ) : (
                <>
                  لطفا مبلغ{' '}
                  <NumberFormat value={(mandeHesabPrice - (discount?.amount / 10 || 0) + parseInt(shippingPrice + '0')) / 10} displayType={'text'} thousandSeparator={true} /> تومان
                  را نیز از طریق درگاه، پرداخت نمایید.
                </>
              )}
            </span>
          )
        ) : (
          <span>آیا مایلید که مبالغ فوق بابت این سند از حساب شما کسر شود؟</span>
        )}

        {/* کسر از اعتبار وزنی */}
        {ENABLE_GOLD_WALLET_IN_CART && goldGramCartUsage > 0 && (
          <>
            <br />
            <span style={{ color: '#01494b', fontWeight: '600' }}>
              کسر از اعتبار وزنی: {goldGramCartUsage} گرم (≈ <NumberFormat value={goldGramCartToman} displayType='text' thousandSeparator={true} /> تومان)
            </span>
          </>
        )}

        {/* پیام بیعانه */}
        {payType === 'deposit' && <p className='mt-3'>توجه : در صورت عدم پرداخت مانده حساب این خرید تا ۲۴ ساعت آینده ، سفارش کنسل شده و مشمول جریمه کنسلی خواهید شد.</p>}
      </>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered={false}
      dialogProps={{
        style: {
          zIndex: '10000000000',
          marginTop: '0',
          marginBottom: 'auto',
          transform: 'translateY(0)',
        },
      }}
    >
      <Modal.Header closeButton={false} style={{ justifyContent: 'end' }}>
        <Modal.Title className='rtl'>تایید نهایی سفارش</Modal.Title>
      </Modal.Header>

      <Modal.Body className='rtl' style={{ fontSize: '.9rem' }}>
        {user['is_teammate'] === 1 ? renderTeammateContent() : renderRegularUserContent()}
      </Modal.Body>

      {/* نمایش کد تخفیف */}
      {!discount.success && (
        <div
          style={{
            textAlign: 'right',
            padding: '0 15px 10px',
            fontSize: '14px',
          }}
        >
          کد تخفیف دارید؟
          <span
            style={{
              color: 'var(--main_green_dark)',
              fontSize: '13px',
              paddingRight: '5px',
              cursor: 'pointer',
            }}
            onClick={onDiscountClick}
          >
            اینجا کلیک کنید
          </span>
        </div>
      )}

      <Modal.Footer>
        <Row style={{ width: '100%' }}>
          <Col style={{ width: '50%', padding: '0px' }}>
            <Button className=' border-0 color-white rounded p-2' style={{ width: '100%', height: '100%', marginRight: '2px' }} onClick={onConfirm}>
              <span>قبول و ادامه</span>
            </Button>
          </Col>
          <Col style={{ width: '50%', padding: '0px' }}>
            <button className='border-0 rounded p-2 modal-buttons btn-disable' style={{ width: '100%', height: '100%', marginLeft: '2px' }} onClick={onHide}>
              <span>انصراف</span>
            </button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
